export const DESKTOP_FOOTER_ID = 'desktop-footer';
export const DESKTOP_HEADER_ID = 'desktop-header';
export const MOBILE_HEADER_ID = 'mobile-header';
export const MOBILE_NAVBAR_ID = 'mobile-navbar';
export const DESKTOP_HEADER_PADDING_RIGHT = 24;
export const DESKTOP_HEADER_PADDING_LEFT = 24;
